import { render, staticRenderFns } from "./page_head.vue?vue&type=template&id=af8e097e&scoped=true&"
import script from "./page_head.vue?vue&type=script&lang=js&"
export * from "./page_head.vue?vue&type=script&lang=js&"
import style0 from "./page_head.vue?vue&type=style&index=0&id=af8e097e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8e097e",
  null
  
)

export default component.exports